
/*
  This component will display selectbox in configurator
 */

import React, {useEffect} from 'react'
import store from "../../store/store";

const Radio = (props) => {

    // This pushes radio buttons and selects them
    const getOptionsForRadio = (attributes, currentValue,radioGroup, checkType) => {
        const labelValue = [];
        const keys = attributes.values.split(",");
        const values = attributes.labels.split(",");
        for (let i = 0; i < keys.length; i++) {
            if (keys[i] == currentValue) {
                labelValue.push({key:keys[i], value:values[i], checked: true, group: radioGroup, checkType: checkType, currentValue: currentValue});
            } else {
                labelValue.push({key:keys[i], value:values[i], checked: false, group: radioGroup, checkType: checkType, currentValue: currentValue});
            }

        }
        return labelValue.map((label, index) =>
            <label className={"enabled label_radio " + (isDisabled(label.key) ? "disabled":"enabled")}   key={label.key + '-' + isDisabled(label.key)} onClick={(e) => handleClick(e)}>
                <input type={label.checkType} style={props.styles ? props.styles : null} disabled={isDisabled(label.key)} key={label.key  + '-' + label.currentValue} value={label.key}  defaultChecked={isDisabled(label.key) ? false:label.checked} onChange={(e) => handleOnChange(e)}></input>
                <b className="checkbox"></b>
                <span>{label.key} - {label.value}</span>
             </label>)
    }

    const handleClick = (e) => {
        if(props.disabled) {
            e.preventDefault()
            return;
        }
        props.onClick(e);
    }

    const isDisabled = (value) => {
        if(props.disabledSelections == null || props.ignoreDisabled){
            return false
        }
        let disabled = props.disabledSelections.includes(value);
        return disabled;
    }

    const handleOnChange =(e) => {
        const val = e.target.checked ? e.target.value:"";
        store.dispatch({type: 'SET_ERRORS', value: false});
        props.handleAttribute(val);
    }

    // Deselects if the option is selected AND disabled
    useEffect(() => {
        if(isDisabled(props.currentValue)){
            props.handleAttribute("");
        }
    })

    return (
        getOptionsForRadio(props.attributes, props.currentValue, props.group, props.checkType)
    )
}

export default Radio;